import { KlaviyoForm } from '@theme/klaviyo-form';

/** Lead capture on the gated-guide download card. Tag name only; behavior is `KlaviyoForm`. */
class GuideDownloadForm extends KlaviyoForm {}

if (!customElements.get('guide-download-form')) {
  customElements.define('guide-download-form', GuideDownloadForm);
}
